import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// PATCH 37 Mi12 — a "back to top" affordance for long-scroll screens (e.g. the verification queue).
export default function BackToTop({ threshold = 500, testid = "back-to-top" }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  if (!show) return null;
  return (
    <button className="k-btn k-btn-ghost k-no-print" data-testid={testid} aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      style={{ position: "fixed", right: 24, bottom: 24, zIndex: 50, borderRadius: 999, padding: "10px 14px",
        background: "var(--container)", boxShadow: "0 6px 20px rgba(17,17,19,.4)" }}>
      <ArrowUp size={15} /> Top
    </button>
  );
}
